import React from 'react';

const ErrorDisplay = ({ solveError }) => {
  if (!solveError) return null;
  
  return (
    <div className="solve-error">
      <p>{solveError}</p>
    </div>
  );
};

export default ErrorDisplay; 